import React from "react";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import Dropdown from "../../UI/Dropdown/Dropdown";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import Modal from "../../UI/Modal/Modal";
import CreateNewNetwork from "../CreateNewNetwork/CreateNewNetwork";
import { useSelector } from "react-redux";

const NetworkMembershipInfo = (props) => {
  const visionImpaired = useSelector((state) => state.layout.visionImpaired);
  const fontSize = useSelector((state) => state.layout.fontSize);

  const { networkMemberInfo, networksList } = props.parentState;

  const { networkUpdateObj } = props.parentState.newFormData;

  const networkMember = [
    { id: 1, value: "DA" },
    { id: 0, value: "NE" },
  ];

  const networkMemberOptions = networkMember.map((element) => (
    <option key={element.id} value={element.id}>
      {element.value}
    </option>
  ));

  const networkListOptions = networksList.map((element) => (
    <option key={element.idMreze} value={element.idMreze}>
      {element.nazMreze}
    </option>
  ));

  let findNetworkObjById;
  if (networkMemberInfo.idMreze) {
    findNetworkObjById = props.parentState.networksList.find(
      (element) => element.idMreze == networkMemberInfo.idMreze
    );
  }

  return (
    <>
      <Row>
        <Col>
          <Dropdown
            style={
              props.required &&
              props.parentState.error &&
              !networkMemberInfo.isDrustvoMreza &&
              "red"
            }
            label={"Članstvo u mreži"}
            hidden
            onChange={props.networkDropdownHandler}
            value={networkMemberInfo.isDrustvoMreza}
            asProperty="select"
            map={networkMemberOptions}
            text="Članstvo u mreži"
          />
        </Col>
        <Col>
          {networkMemberInfo.isDrustvoMreza > 0 && (
            <Dropdown
              style={
                props.required &&
                props.parentState.error &&
                !networkMemberInfo.idMreze &&
                "red"
              }
              label={"Odaberite mrežu*"}
              onChange={props.setSelectedNetworkDropdown}
              value={networkMemberInfo.idMreze}
              hidden
              asProperty="select"
              map={networkListOptions}
              text="Odaberite mrežu"
            />
          )}
        </Col>
      </Row>
      {networkMemberInfo.idMreze && networkMemberInfo.isDrustvoMreza > 0 && (
        <CreateNewNetwork
          {...props}
          group={"createNewNetworkData"}
          disabled
          createNewNetworkData={findNetworkObjById}
        />
      )}
      <Row>
        <Col className="col-lg-8">
          {networkMemberInfo.isDrustvoMreza > 0 && (
            <ButtonComponent onClick={props.createNewNetworkModal}>
              Kreiraj mrežu
            </ButtonComponent>
          )}
        </Col>
        <Col className="col-lg-8">
          {networkMemberInfo.isDrustvoMreza > 0 &&
            networkMemberInfo.idMreze != "" && (
              <ButtonComponent onClick={props.openNetworkUpdateModal}>
                Ažuriraj mrežu
              </ButtonComponent>
            )}
        </Col>
      </Row>
      <Modal
        size="xl"
        show={props.parentState.newFormData.createNewNetworkModal}
        onHide={props.createNewNetworkModal}
        title={"Kreiranje nove mreže"}
        className={`${props.className} ${
          visionImpaired ? " visionImpaired" : ""
        }  font${fontSize}`}
      >
        <CreateNewNetwork
          group={"createNewNetworkData"}
          createNewNetworkData={
            props.parentState.newFormData.createNewNetworkData
          }
          {...props}
          required
        />
      </Modal>
      <Modal
        size="xl"
        show={props.parentState.showUpdateModal}
        onHide={props.hideUpdateModal}
        title={"Ažuriranje mreže"}
        className={`${props.className} ${
          visionImpaired ? " visionImpaired" : ""
        }  font${fontSize}`}
      >
        <CreateNewNetwork
          group={"networkUpdateObj"}
          update
          createNewNetworkData={networkUpdateObj}
          {...props}
          required
        />
      </Modal>
    </>
  );
};

export default NetworkMembershipInfo;
